export default {"src":"/_next/static/media/arrow-right.bd9ef851.svg","height":17,"width":10};